import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}

// 分页查询体检报告模板
export const getReportTemplate = (data) => {
	return request({
		url: '/health/web/tmpl/page-template-info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 新增体检报告模板
export const addReportTemplate = (data) => {
	return request({
		url: '/health/web/tmpl/add-template',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 编辑体检报告模板
export const updateReportTemplate = (data) => {
	return request({
		url: '/health/web/tmpl/edit-template-info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 删除体检报告模板
export const delReportTemplate = (data) => {
	return request({
		url: '/health/web/tmpl/delete-template-info',
		method: 'post',
		data: { ...dataObj, content: data.medicalTemplateId || undefined }
	})
}

// 根据模板id查询体检报告模板详情
export const getReportTemplateDetail = (data) => {
	return request({
		url: '/health/web/tmpl/get-template-info',
		method: 'post',
		data: { ...dataObj, content: data.medicalTemplateId || undefined }
	})
}

// 新增营养科普
export const addArticle = (data) => {
	return request({
		url: '/health/web/popularscience/add-article',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分页查询营养科普列表
export const getArticle = (data) => {
	return request({
		url: '/health/web/popularscience/page-article',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 编辑营养科普
export const editArticle = (data) => {
	return request({
		url: '/health/web/popularscience/edit-article',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 删除营养科普
export const delArticle = (data) => {
	return request({
		url: '/health/web/popularscience/del-article',
		method: 'post',
		data: { ...dataObj, content: data.articleId || undefined }
	})
}

// 新增营养顾问
export const addAdviser = (data) => {
	return request({
		url: '/health/web/adviser/add-adviser',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分页查询营养顾问列表
export const getAdviser = (data) => {
	return request({
		url: '/health/web/adviser/page-advisers',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 编辑营养顾问
export const editAdviser = (data) => {
	return request({
		url: '/health/web/adviser/edit-adviser',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 删除营养顾问
export const delAdviser = (data) => {
	return request({
		url: '/health/web/adviser/del-adviser',
		method: 'post',
		data: { ...dataObj, content: data.adviserId || undefined }
	})
}

// 新增健康菜谱
export const addHealthrecipe = (data) => {
	return request({
		url: '/health/web/healthrecipe/add-healthrecipe',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分页查询健康菜谱列表
export const getHealthrecipe = (data) => {
	return request({
		url: '/health/web/healthrecipe/page-healthrecipe',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 编辑健康菜谱
export const editHealthrecipe = (data) => {
	return request({
		url: '/health/web/healthrecipe/edit-healthrecipe',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 查询指定健康菜谱详情
export const getHealthrecipeDetail = (data) => {
	return request({
		url: '/health/web/healthrecipe/list-healthrecipe-detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 删除健康菜谱
export const delHealthrecipe = (data) => {
	return request({
		url: '/health/web/healthrecipe/del-healthrecipe',
		method: 'post',
		data: { ...dataObj, content: data.healthRecipeId || undefined }
	})
}

// 查询人员每日参考摄入量
export const getCustIntake = (data) => {
	return request({
		url: '/health/web/catering/get-cust-intake',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 查询人员营养配餐
export const getCateringDetail = (data) => {
	return request({
		url: '/health/web/catering/list-catering-detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 编辑人员营养配餐
export const editCateringDetail = (data) => {
	return request({
		url: '/health/web/catering/edit-catering',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 删除人员营养配餐
export const delCateringDetail = (data) => {
	return request({
		url: '/health/web/catering/del-catering',
		method: 'post',
		data: { ...dataObj, content: data.custId || undefined }
	})
}

// 查询人员体检报告详情
export const getMedicalreportInfo = (data) => {
	return request({
		url: '/health/web/cust/get-medicalreport-info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 根据人员体检id查询报告详情
export const getMobileMedicalreportInfo = (data) => {
	return request({
		url: '/health/mobile/medicalreport/get-medicalreport-info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 编辑人员体检报告
export const editMedicalreportInfo = (data) => {
	return request({
		url: '/health/web/cust/edit-medicalreport',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 删除人员体检报告
export const delMedicalreportInfo = (data) => {
	return request({
		url: '/health/web/cust/delete-medicalreport',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 体检项目历史数据分析
export const getAnalysis = (data) => {
	return request({
		url: '/health/web/cust/get-history-report-analysis',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 获取一周摄入图表数据
export const getIntakeAnalysis = (data) => {
	return request({
		url: '/health/web/dietreport/get-intake-analysis',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 查询摄入详情
export const getAnalysisDetail = (data) => {
	return request({
		url: '/health/web/dietreport/query-diet-report',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 膳食宝塔模式查询
export const getMealPattern = (data) => {
	return request({
		url: '/health/web/analysis/page-meal-pattern',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 保存健康菜谱信息(营养配餐设为健康菜谱用)
export const saveHealthrecipe = (data) => {
	return request({
		url: '/health/web/healthrecipe/save-healthrecipe',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分页查询健康咨询列表
export const getConsults = (data) => {
	return request({
		url: '/health/web/consult/page-consults',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 健康咨询回复
export const consultReply = (data) => {
	return request({
		url: '/health/web/consult/reply',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 批量删除营养顾问
export const plDelAdviser = (data) => {
	return request({
		url: '/health/web/adviser/list-del-adviser',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 批量删除营养科普
export const plDelArticle = (data) => {
	return request({
		url: '/health/web/popularscience/list-del-article',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 批量删除体检报告模板信息
export const plDelTemplateInfo = (data) => {
	return request({
		url: '/health/web/tmpl/list-delete-template-info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
